<template>
  <div class="switcher-wrapper">
    <div class="switcher-item">
      <input
        id="radio-call-0"
        v-model="dataModelChecked"
        :value="null"
        type="radio"
        name="radio-call"
        @click="clickAction(null)">
      <label for="radio-call-0">All</label>
    </div>

    <div class="switcher-item">
      <input
        id="radio-call-2"
        v-model="dataModelChecked"
        value="running"
        type="radio"
        name="radio-call"
        @click="clickAction('running')">
      <label for="radio-call-2">Running</label>
    </div>
    <div class="switcher-item">
      <input
        id="radio-call-3"
        v-model="dataModelChecked"
        value="complete"
        type="radio"
        name="radio-call"
        @click="clickAction('complete')">
      <label for="radio-call-3">Complete</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CallAutoStatus',

  props: {
    value: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      dataModelChecked: this.value
    };
  },

  watch: {
    dataModelChecked (val) {
      this.$emit('input', val);
    },

    value (val) {
      this.dataModelChecked = val;
    }
  },

  methods: {
    clickAction (type) {
      if (this.dataModelChecked === type) {
        this.dataModelChecked = null;
      }
    }
  }
};
</script>
